import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sortEventsDesc } from "../../../../utils/events";
import moment from "moment";

const EventRightArea = ({ evt }) => {
  const [events, setEvents] = useState([]);
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const base = process.env.PUBLIC_URL || "";

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events?populate[address][populate][0]=city&populate[contact][populate]=*&populate[listImage][populate]=*&populate[detailsImage][populate]=*&populate[thumbnailImage][populate]=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        data?.data?.sort(sortEventsDesc);
        setEvents((data?.data || []).filter((x) => x.id !== evt?.id).slice(0, 5));
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, [evt?.id]);

  return (
    <div className="hn-detail-sidebar">
      <div className="hn-sidebar-card">
        <h4><i className="bi bi-layout-text-sidebar-reverse" /> Recent Events</h4>
        <ul className="hn-sidebar-list">
          {events.map((event) => (
            <Link
              key={event.id}
              to={`${base}/events/${event.id}`}
              className="hn-sidebar-item"
            >
              <img
                src={`${apiBase}${event?.attributes?.thumbnailImage?.data?.attributes?.url}`}
                alt=""
              />
              <div>
                <strong>{event.attributes?.title}</strong>
                <span><i className="bi bi-calendar2-week" /> {moment(event.attributes?.startDate).format("DD MMM, YY")}</span>
              </div>
            </Link>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default EventRightArea;
